import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  inputContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "15px 0",
  },
  searchBox: {
    margin: 0,
    height: 40,
  },
  formContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    alignItems: "flex-start",
    marginBottom: "15px",
  },
  fieldWrapper: {
    display: "flex",
    flexDirection: "column",
    flex: "1 1 250px",
    minWidth: "250px",
  },
  labelInput: {
    height: "40px",
    width: "100%",
    padding: "0 8px",
    margin: "0 0 4px 0",
    borderRadius: "5px",
  },
  addButtonContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "18px",
  },
  addButton: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "16px",
    color: "#FFFFFF",
    backgroundColor: "#4D1277",
    textTransform: "capitalize",
    borderRadius: "5px",
    padding: "8px 16px",
    height: "40px",
  },
  fieldStyle: {
    width: "100%",
    height: "40px",
    fontSize: 14,
    padding: "7px 8px",
    color: "#272525",
    fontWeight: 400,
    border: "1px solid #999999",
    borderRadius: "5px",
    boxShadow: "none",
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #999999",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #999999",
    },
  },
  errorStyle: {
    marginTop: "0 !important",
  },

  fieldText: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "100%",
    color: "#000000",
    marginBottom: "5px",
  },
}));

export default useStyles;
